import { GlobalComponent } from "src/app/global-component";
import { RowActionsModel } from "./row-actions.model";
import { ColumnsModel } from "./list-layout-models/columns.model";
import { ListFilterModel } from "./list-filter.model";
import { SearchBarFilterModel } from "./searchbar-filter.model";
import { ButtonsModel } from "./buttons.model";
import { ActionIdEnum } from "../../enums/list-layout/action-id-enum";
import { DateFilterModel } from "./date-filter.model";
import { BaseModel } from "../base.model";
import { environment } from "src/environments/environment";

export class TableConfigurationModel extends BaseModel {
    columns: ColumnsModel[] = [];
    displayTabulation?: boolean = false;
    actions: RowActionsModel[] = [];
    filters: ListFilterModel[] | undefined =  undefined; 
    buttons: ButtonsModel[] = []; 
    searchbarFilter?: SearchBarFilterModel;
    dateFilter?: DateFilterModel; 
    listTitle: string | undefined;
    customizedListTitle: string | undefined;
    pageSize: number = GlobalComponent.defaultPagingInfo.pageSize;
    pageSizeFilter?: { pageSize: number }[] = undefined; 
    showArrangeOptions: boolean |undefined = true; 
    doubleClickSelect?: {action: ActionIdEnum, enabled: boolean };
    activeInputFieldIndex?: number;
    enablePagination: boolean = true; 
    version: string = environment.tableConfigVersion;
    canConfigBeSavedToServer: boolean = false;
    showReload: boolean = false;
}
